module.exports = __webpack_public_path__ + "userCenter-change-amend-3bbed03e.png";